const getPartnerUrl = (partner, conferenceName) => {
    // Получаем уникальный идентификатор партнера (предположим, что у вас есть поле partnerId)
    const partnerName = partner.partnerName;

    // Объект, сопоставляющий уникальный идентификатор партнера с его частью URL
    const partnerUrls = {
        "Industry Events": "https://www.industryevents.com/",
        "The Plant Base": "https://www.theplantbasemag.com/",
        "Foodbev Media": "https://www.foodbev.com/",
        "10 Times": "https://10times.com/",
        "WORLD CONFERENCE ALERTS": "https://www.worldconferencealerts.com/",
        "Conference locate": "https://www.clocate.com/"
        // Добавьте других партнеров и соответствующие им URL
    };

    // Получаем часть URL в зависимости от партнера или используем пустую строку, если нет совпадений
    const partnerUrlPart = partnerUrls[partnerName] || '';

    // Объект, сопоставляющий название конференции с её частью URL
    const conferenceUrls = {
        "INTERNATIONAL HRD SUMMIT": "events/international-hrd-summit",
        "2ND ANNUAL GENOTOXICITY AND NITROSAMINE ONLINE CONFERENCE": "events/2nd-annual-genotoxicity-and-nitrosamine-summit",
        // Добавьте другие конференции и соответствующие им части URL
    };

    // Получаем часть URL в зависимости от конференции или используем пустую строку, если нет совпадений
    const conferenceUrlPart = conferenceUrls[conferenceName] || '';

    // Собираем конечный URL
    const finalUrl = partnerUrlPart + conferenceUrlPart;

    return finalUrl;
};

export default getPartnerUrl;
